import { ctaDestinationForPath } from '@app/_shared/telemetry/ctaTelemetry';

const PLACEMENT_BY_DESTINATION = {
    pricing: 'topnav_pricing',
    checkout: 'topnav_join',
    sign_up: 'topnav_join',
    log_in: 'topnav_login',
} as const;

const SITE_ORIGIN = 'https://www.storyblocks.com';

export function topNavActionPlacement(href: string): string | undefined {
    const destination = ctaDestinationForPath(pathnameOf(href));
    return destination === undefined ? undefined : PLACEMENT_BY_DESTINATION[destination];
}

function pathnameOf(href: string): string {
    try {
        return new URL(href, SITE_ORIGIN).pathname;
    } catch {
        return '';
    }
}
